( function () {
    'use strict';
    e.bootstrap = e.bootstrap || {};
    e.bootstrap.affix = {};
    e.bootstrap.affix.init = function () {
        e.bootstrap.affix.setAffix();
        e.bootstrap.affix.addPlaceholder();
        e.bootstrap.affix.setPlaceholderHeight();
        e.bootstrap.affix.bindEvents();
    };
    e.bootstrap.affix.setAffix = function () {
        var jNavGlobalTop = jQuery( '.js-e-nav-global-top' ),
            jNavLocalTop = jQuery( '.js-e-nav-local-top' );
        if ( jNavLocalTop.length === 1 && screen.height > 767 ) {
            jNavLocalTop.removeData( 'affix' ).removeClass( 'affix affix-top affix-bottom' );
            jNavLocalTop.affix( {
                offset: {
                    top: jNavLocalTop.position().top
                }
            } );
        }
        else if ( jNavGlobalTop.length === 1 && screen.height > 480 ) {
            jNavGlobalTop.removeData( 'affix' ).removeClass( 'affix affix-top affix-bottom' );
            jNavGlobalTop.affix( {
                offset: {
                    top: jNavGlobalTop.position().top
                }
            } );
        }
    };
    e.bootstrap.affix.addPlaceholder = function () {
        var jNavGlobalTop = jQuery( '.js-e-nav-global-top' ),
            jNavLocalTop = jQuery( '.js-e-nav-local-top' );
        if ( jNavLocalTop.length === 1 && screen.height > 767 ) {
            jNavLocalTop.wrap( jQuery( '<div />' ).addClass( 'js-e-nav-sticky-wrapper' ).css( {
                'min-height': jNavLocalTop.outerHeight( true )
            } ) );
        }
        else {
            jNavGlobalTop.wrap( jQuery( '<div />' ).addClass( 'js-e-nav-sticky-wrapper' ).css( {
                'min-height': jNavGlobalTop.outerHeight( true )
            } ) );
        }
    };
    e.bootstrap.affix.setPlaceholderHeight = function () {
        jQuery( '.js-e-nav-sticky-wrapper' ).css( 'min-height', function () {
            return jQuery( this ).children().first().outerHeight( true );
        } );
    };
    e.bootstrap.affix.bindEvents = function () {
        e.constant.jWindow.on( 'resize', function () {
            e.constant.jWindow.off( '.affix' );
            e.bootstrap.affix.setAffix();
            e.bootstrap.affix.setPlaceholderHeight();
        } );
    };
}() );
